import React, { Component } from 'react';
import { T } from '../../../../../common/locale/translate';

class BlogMobileSearchForm extends Component {
  constructor() {
    super();
    this.state = {
      active: false
    };
  }

  render() {
    return (
      <section className="blog-search">
        <div className="mobile-action-wrapper">
          <button onClick={this.handleMobileToggle} className="search-button">
            {T('search_blog')}
            <i className="fa fa-search" aria-hidden="true" />
          </button>
        </div>
        <div
          className={`search-form-outside-wrapper ${
            this.state.active ? 'active' : ''
          }`}
        >
          <div className="mobile-header-wrapper">
            <h3 className="mobile-header">
              {T('search_blog')}
              <i
                className="fa fa-times mobile-toggle-switch"
                aria-hidden="true"
                onClick={this.handleMobileToggle}
              />{' '}
            </h3>
          </div>
          <div className="search-form-inside-wrapper">
            <form action="/blog">
              <div className="blog-search-form">
                <p>{T('search_blog')}</p>
                <input type="text" name="search" className="blog-text-input" />
              </div>
              <div className="action-wrapper">
                <button type="submit" className="search-button">
                  <i className="fa fa-search" aria-hidden="true" />
                  <span>{T('look_for')}</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    );
  }

  handleMobileToggle = () => {
    if (document) {
      document.body.classList.toggle('modal-visible');
    }
    this.setState({ active: !this.state.active });
  };
}

export default BlogMobileSearchForm;



// WEBPACK FOOTER //
// ./app/javascript/pages/blog/components/blog_mobile_search.jsx